import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '@greco-fit/scaffolding';
import { UpdateResourceTagDto } from '@greco/nestjs-booking-events';
import { Subject } from 'rxjs';
import { startWith, takeUntil } from 'rxjs/operators';
@Component({
  selector: 'greco-update-tag',
  templateUrl: './update-tag.dialog.html',
  styleUrls: ['./update-tag.dialog.scss'],
})
export class UpdateTagDialog implements OnInit, OnDestroy {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { communityId: string; tagId: string; label: string },
    private formBuilder: FormBuilder
  ) {}

  private _onDestroy$ = new Subject<void>();

  form = this.formBuilder.group({
    label: [this.data.label || '', Validators.required],
  });

  dialogData: DialogData = {
    title: 'Update Tag',
    subtitle: 'Provide details to update the tag',
    showCloseButton: false,
    buttons: [
      { label: 'Cancel', role: 'cancel' },
      {
        label: 'Update',
        role: 'update',
        disabled: this.form.errors?.length,
        resultFn: async () => {
          try {
            const tag: UpdateResourceTagDto = {
              id: this.data.tagId,
              label: this.form.value.label,
              communityId: this.data.communityId,
            };
            return tag;
          } catch (err) {
            console.error(err);
            return null;
          }
        },
      },
    ],
  };

  ngOnInit() {
    this.form.valueChanges.pipe(startWith(this.form.value), takeUntil(this._onDestroy$)).subscribe(() => {
      this.dialogData = {
        ...this.dialogData,
        buttons: this.dialogData.buttons?.map(btn => {
          if (btn.role === 'update') btn.disabled = this.form.invalid;
          return btn;
        }),
      };
    });
  }

  ngOnDestroy() {
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }
}
